import "./BasicListItem.scss";
import {
  ArrowLineUpRightIcon,
  ArrowRightIcon,
  DownloadSimpleIcon,
  FilePdfIcon,
} from "/App.Components";
import { BasicListItemProps } from "/Models/Generated/BasicListItemProps";
import { ColorTheme } from "/Models/Models/ColorTheme";

const BasicListItem = ({
  title,
  published,
  isDownloadable,
  isPdf,
  link,
}: BasicListItemProps) => {
  const IconComp = isDownloadable
    ? DownloadSimpleIcon
    : link?.isExternal
      ? ArrowLineUpRightIcon
      : isPdf
        ? FilePdfIcon
        : ArrowRightIcon;

  return (
    <a className="basic-list-item-norad" href={link?.href}>
      <div className="basic-list-item-norad__content-wrapper">
        <h2>
          <span className="basic-list-item-norad__text">{title}</span>
        </h2>

        {published && (
          <div className="basic-list-item-norad__published">
            {published?.publishedLabel} {published?.publishedDate}
          </div>
        )}
      </div>
      <div className="basic-list-item-norad__icon-wrapper">
        <IconComp size="32" thickness="Light" color={ColorTheme.default} />
      </div>
    </a>
  );
};
export default BasicListItem;
